const toolsList = () => import('./toolsList');
const jpLanguageList = () => import('./jpLanguageList');


const salesToolsRouter = [
  {
    path: '/salesTools/toolsList/', name: 'toolsList', component: toolsList, meta: { c: 'salesTools', a: 'toolsList' }
  },
  {
    path: '/salesTools/jpLanguageList/:id', name: 'jpLanguageList', component: jpLanguageList, meta: { c: 'salesTools', a: 'jpLanguageList' }
  },
];

export default salesToolsRouter;
